module.exports = __webpack_public_path__ + "static/avatar-6e368dfcffb6437a73287b752a2a1a37.jpg";